/* ===========================================================================
 Search
 =========================================================================== */

import Vue from 'vue';
import $ from 'jquery';
import searchResultCount from './search/searchResultCount.vue';
import searchQuery from './search/searchQuery.vue';
import searchUserResult from './search/searchUserResult.vue';
import {visibleClass} from '../settings/settings';

let searchHeaderVue,
    searchResultVue,
    searchUserResultVue,
    searchUserHeaderVue,
    paginationVue;

document.addEventListener('DOMContentLoaded', () => {
    /** @type {HTMLFormElement} */
    const searchFiltersForm = document.getElementById('search-filters-form');
    const submit = searchFiltersForm.querySelector('.search-filters-submit');
    searchFiltersForm.addEventListener('change', () => submit.classList.remove('is-hidden'));
    let initialEvent = true;
    $(searchFiltersForm.querySelector('[data-slider]')).on('changed.zf.slider', () => {
        if (initialEvent) {
            initialEvent = false;
            return;
        }
        searchFiltersForm.dispatchEvent(new Event('change'));
    });
    searchFiltersForm.querySelectorAll('.search-filters-show-more').forEach(button => {
        const rows = button.parentElement.querySelectorAll('.row');
        const limit = Number(button.dataset.showMore);
        const label = button.querySelector('span');
        const initialLabel = label.textContent;
        let expanded = false;
        button.addEventListener('click', () => {
            expanded = !expanded;
            button.classList.toggle('is-active', expanded);
            label.textContent = expanded ? button.dataset.showLessLabel : initialLabel;
            rows.forEach((row, index) => {
                row.classList.toggle('is-hidden', !(expanded || index < limit));
            });
        });
    });
});

if (document.getElementById('js-search-user-header')) {
    searchUserHeaderVue = new Vue({
        el: '#js-search-user-header',
        components: {
            searchResultCount,
            searchQuery,
        },
    });

    searchUserResultVue = new Vue({
        el: '#js-search-user-results',
        components: {
            searchUserResult,
        },
    });
}

export const $searchForm = document.getElementById('js-search-form');
export const $searchTriggers = document.querySelectorAll('.js-accordion-research');
export const $searchFormText = document.getElementById('js-open-search-form');
export const $searchInputText = document.getElementById('js-search-term');
const $resetButtonTextId = document.getElementById('js-reset-search-text');
const $paginationContainer = document.getElementById('js-pagination');
const $brandField = $('#filter_brand');
const $sortField = $('#filter_sort');

export class Search {
    reload(page) {
        if (!searchHeaderVue) {
            return;
        }

        searchResultVue.$refs['js-search-result'].showLoader();

        const searchTerm = $searchInputText.value;
        const formData = new FormData($searchForm);
        let url = $searchForm.action;

        const allUniverses = formData.getAll('filter[gender][]');
        let noChangedUrl = true;

        if (allUniverses.length > 0) {
            url = url + '/' + allUniverses[0];
        } else {
            noChangedUrl = false;
        }

        const allRanges = formData.getAll('filter[range][]');

        formData.delete('filter[range][]');
        allRanges.forEach(values => {
            if (values.includes(',')) {
                let valuesSplitted = values.split(',');
                valuesSplitted.forEach(value => formData.append('filter[range][]', value));
            } else {
                formData.append('filter[range][]', values);
            }
        });

        if (allRanges.length > 0 && noChangedUrl) {
            url = url + '/' + allRanges[0];
        } else {
            noChangedUrl = false;
        }

        const allCategories = formData.getAll('filter[category][]');

        formData.delete('filter[category][]');
        allCategories.forEach(values => {
            if (values.includes(',')) {
                let valuesSplitted = values.split(',');
                valuesSplitted.forEach(value => formData.append('filter[category][]', value));
            } else {
                formData.append('filter[category][]', values);
            }
        });

        if (allCategories.length > 0 && noChangedUrl) {
            url = url + '/' + allCategories[0];
        }

        const allSizes = formData.getAll('filter[size][]');
        formData.delete('filter[size][]');
        allSizes.forEach(values => {
            if (values.includes(',')) {
                let valuesSplitted = values.split(',');
                valuesSplitted.forEach(value => formData.append('filter[size][]', value));
            } else {
                formData.append('filter[size][]', values);
            }
        });

        if (searchTerm.length) {
            formData.append('search', searchTerm);
        }

        if (page) {
            formData.append('page', page);
        }

        const queryString = new URLSearchParams(formData);

        let keysForDel = [];
        queryString.forEach((value, key) => {
            if (value == '' || key == 'filter[_token]') {
                keysForDel.push(key);
            }
            /*if (url.includes(value))
            {
              this.deleteSearchParamByKeyValue(queryString, key, value);
            }*/
        });

        keysForDel.forEach(key => {
            queryString.delete(key);
        });

        window.location = url + '?' + queryString;

        return fetch(url, {
            method: $searchForm.method,
            headers: new Headers({
                'X-Requested-With': 'XMLHttpRequest',
            }),
            credentials: 'include', // https://developer.mozilla.org/en-US/docs/Web/API/Request/credentials
            body: formData,
        }).then(response => {
            if (response.ok && response.status === 200) {
                return response.json();
            }
        });
    }

    deleteSearchParamByKeyValue(searchParams, key, value) {
        const allKeys = [];
        const entriesToKeep = [];
        for (const [k, v] of searchParams.entries()) {
            if (k === undefined || v === undefined) {
                continue;
            }
            allKeys.push(k);
            if (k === key && v === value) {
                continue;
            }
            entriesToKeep.push([k, v]);
        }

        for (const k of allKeys) {
            searchParams.delete(k);
        }

        for (const [k, v] of entriesToKeep) {
            searchParams.append(k, v);
        }
    }

    getLastPage() {
        return parseInt(paginationVue.$refs['js-pagination'].lastPage);
    }

    initPage() {
        this.page = parseInt(paginationVue.$refs['js-pagination'].page);
        return this.page;
    }

    getPage() {
        return this.page || this.initPage();
    }

    getNextPage() {
        return paginationVue.$refs['js-pagination'].nextPage;
    }

    isLock() {
        return paginationVue.$refs['js-pagination'].isLock();
    }

    lock() {
        return paginationVue.$refs['js-pagination'].lock();
    }

    unLock() {
        return paginationVue.$refs['js-pagination'].unLock();
    }

    submit(page) {
        let result = this.reload(page);
        result && result.then(data => {
            if (data) {
                searchHeaderVue.$refs['js-search-count'].updateMessage(data.countMessage);
                searchHeaderVue.$refs['js-search-query'].updateQuery(data.queryTerm);
                searchResultVue.$refs['js-search-result'].updateResult(data.result);

                paginationVue.$refs['js-pagination'].update(data.page, data.lastPage, data.totalHits);
            }
        });
    }

    paginate() {
        this.reload(this.getNextPage())
            .then(data => {
                this.page++;
                searchHeaderVue.$refs['js-search-count'].updateMessage(data.countMessage);
                searchHeaderVue.$refs['js-search-query'].updateQuery(data.queryTerm);
                searchResultVue.$refs['js-search-result'].concatResult(data.result);
                paginationVue.$refs['js-pagination'].update(data.page, data.lastPage);
            });
    }


}

var runSearch = function (e) {
    e.preventDefault();

    const search = new Search();
    search.submit();
};

if ($searchForm) {
    $searchInputText.addEventListener('change', runSearch);
    $searchFormText.addEventListener('submit', runSearch);
    $searchTriggers.forEach((trigger) => trigger.addEventListener('click', runSearch));
    $brandField.on('select2:select', runSearch);
    $sortField.change(runSearch);
    $paginationContainer.addEventListener('click', event => {
        if (!event.target.matches('.pagination-item')) {
            return;
        }
        const page = parseInt(event.target.dataset.page);
        new Search().submit(page);
    });
}

if ($searchInputText) {
    $($searchInputText).bind('focus', function () {
        var selectedSearchType = $(this).parent().parent().find('.l-dropdown-selected-value').attr('data-value');
        if ($(this).parent().parent().find('#search-type').find('option[value="' + selectedSearchType + '"]')) {
            var selectedOption = $(this).parent().parent().find('#search-type').find('option[value="' + selectedSearchType + '"]');
            if (parseInt($(selectedOption).attr('autocomplete')) == 1) {
                var that = this;
                $(this).bind('keyup', function () {
                    if ($(this).val().length > 2) {
                        const query = $(this).val();
                        const url = $(selectedOption).attr('ref-action') + '?search=' + query;
                        $.ajax({
                            xhrFields: {
                                withCredentials: true,
                            },
                            dataType: 'json',
                            url,
                        }).success(function (response) {
                            let cList = $('<ul/>');
                            if (response.result.length > 0) {
                                $(response.result).each(function (i, row) {
                                    var li = $('<li/>')
                                        .appendTo(cList);
                                    var label = '';
                                    switch ($(selectedOption).val()) {
                                        default:
                                        case 'product':
                                            label = row.name;
                                            break;
                                        case 'member':
                                            label = row.username;
                                            break;
                                    }
                                    var aaa = $('<a class="underline-only"/>')
                                        .text(label)
                                        .appendTo(li);
                                });

                                $(cList).find('li').on('click', function () {
                                    $($searchInputText).val($(this).text());
                                    $('#autocomplete-container').hide();
                                });
                                $('#autocomplete-container').html(cList);
                                $('#autocomplete-container').show();
                            } else {
                                $('#autocomplete-container').hide();
                            }
                        });
                    }
                });
            } else {
                $(this).unbind('keyup');
            }
        }
    });

    $($searchInputText).bind('input change focus blur', function () {
        if (!$(this).val()) {
            $($resetButtonTextId).removeClass(visibleClass);
        } else {
            $($resetButtonTextId).addClass(visibleClass);
        }
    });

    $($resetButtonTextId).on('click', function (e) {
        e.preventDefault();
        $($searchInputText).val('');
        $($resetButtonTextId).removeClass(visibleClass);
    });
}
